module.exports = __webpack_public_path__ + "static/img/carousel-banner-general-prompstart.2b5dd38.jpg";